import Fetcher from '../../../services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from '../../../constants'
import {
  ExportRejectedInvoicesRequest,
  ExportRejectedInvoicesResponse,
  RejectedInvoiceLine,
  RejectedInvoicesResponse,
  StatusRejectedInvoicesRequest,
  StatusRejectedInvoicesResponse
} from './types'
import { TQueryParams } from '../../../components/Table/types'
import { CancelToken } from 'axios'

const fetcher = new Fetcher({})

export const getRejectedInvoices = async (data: {
  params?: TQueryParams
  cancelToken?: CancelToken
}) =>
  fetcher.request<unknown, RejectedInvoicesResponse>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.REJECTED}`,
    method: HTTP_METHODS.GET,
    ...data
  })

export const exportRejectedInvoices = async (data) =>
  fetcher.request<
    ExportRejectedInvoicesRequest,
    ExportRejectedInvoicesResponse
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.REJECTED}${API_DICTIONARY.DOWNLOAD}`,
    method: HTTP_METHODS.POST,
    data
  })

export const getCurrentStatusRejectedInvoices = async ({ task_id }) =>
  fetcher.request<
    StatusRejectedInvoicesRequest,
    StatusRejectedInvoicesResponse
  >({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.REJECTED}${API_DICTIONARY.DOWNLOAD}${API_DICTIONARY.STATUS}${task_id}/`,
    method: HTTP_METHODS.GET
  })

export const sendEditedLines = async (lines: RejectedInvoiceLine[]) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.FINANCES}${API_DICTIONARY.INVOICES}${API_DICTIONARY.REJECTED}`,
    method: HTTP_METHODS.POST,
    successMessage: 'Invoice data has been updated',
    data: {
      lines
    }
  })
